import { defineNuxtPlugin } from '#app/nuxt'
import { LazyNuxtIcon } from '#components'
const lazyGlobalComponents = [
  ["NuxtIcon", LazyNuxtIcon]
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
